import { getInput } from "../../ui";

const responsiveColumnClasses = {
  "grid-cols-2": "grid-cols-1 md:grid-cols-2",
  "grid-cols-3": "grid-cols-1 sm:grid-cols-2 lg:grid-cols-3",
  "grid-cols-4": "grid-cols-1 sm:grid-cols-2 xl:grid-cols-4",
  "grid-cols-5": "grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-5",
  "grid-cols-6": "grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-6",
  "grid-cols-7": "grid-cols-1 sm:grid-cols-2 md:grid-cols-4 xl:grid-cols-7",
  "grid-cols-8": "grid-cols-1 sm:grid-cols-2 md:grid-cols-4 xl:grid-cols-8",
  "grid-cols-9": "grid-cols-1 sm:grid-cols-2 md:grid-cols-4 xl:grid-cols-9",
  "grid-cols-10": "grid-cols-1 sm:grid-cols-2 md:grid-cols-5 xl:grid-cols-10",
  "grid-cols-11": "grid-cols-1 sm:grid-cols-2 md:grid-cols-6 xl:grid-cols-11",
  "grid-cols-12": "grid-cols-1 sm:grid-cols-2 md:grid-cols-6 xl:grid-cols-12",
};

const getResponsiveGridClassName = (className = "") => {
  const hasResponsiveColumns =
    /\b(?:sm|md|lg|xl|2xl):grid-cols-\d+\b/.test(className);
  if (hasResponsiveColumns) return className;

  return className.replace(
    /\bgrid-cols-(?:[2-9]|1[0-2])\b/,
    columns => responsiveColumnClasses[columns] || columns,
  );
};

const GridInputs = props => {
  const { className, inputs, formik } = props || {};

  if (inputs) {
    return (
      <div className={`grid h-fit min-w-0 ${getResponsiveGridClassName(className)}`}>
        {inputs?.map((item, index) => {
          const itemProps = {
            ...item,
            formik,
          };

          return <GridInputs key={index} {...itemProps} />;
        })}
      </div>
    );
  } else {
    const inputProps = {
      ...props,
      formik,
    };
    return inputProps.type === "title" ? (
      <div className={"mt-10"}>{inputProps.label}</div>
    ) : (
      <>{getInput(inputProps)}</>
    );
  }
};

export { getResponsiveGridClassName, GridInputs };
